/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import { useIsQueryOwner } from '@/hooks'
import { Routes } from '@/assets/configs'
import { useTranslation } from 'next-i18next'

import { Box } from '@mui/material'
import { EmtTypography, useMobile } from 'emt-components-v2'
import PetSitterCard from '@/components/PetSitter/PetSitterCard/PetSitterCard'
import NextImage from 'next/image'
import VariantImages from '@/assets/VariantImages'
import LinkButton from '@/components/EMT/LinkButton'
import { PetSitterProfile } from '@/data/PetSitter/PetSitterProfile'

interface SimilarsProps {
  data: PetSitterProfile[]
}

export const Similars: React.FC<SimilarsProps> = ({ data }) => {
  const [isMobile] = useMobile()
  const tp = useTranslation('petsitter').t
  const [, , appendQueryType] = useIsQueryOwner()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <Box sx={{ display: 'flex' }}>
        <EmtTypography sx={{ display: 'inline' }} variant="h4" fontWeight={800}>
          Pet
        </EmtTypography>
        <NextImage className="inline m-[0.4em] mt-0" width={56} height={26} src={VariantImages.Sitter} alt="sitter" />
        <EmtTypography sx={{ display: 'inline' }} variant="h4" fontWeight={800}>
          {tp(`dashboard.newPetSitter.similars`)}
        </EmtTypography>
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '20px 25px' }}>
        {data.map((sitter, index) => (
          <PetSitterCard small key={sitter?.['@id'] || index} data={sitter} />
        ))}
      </Box>

      <Box sx={{ alignSelf: 'center' }}>
        <LinkButton style={{ marginTop: '25px' }} href={appendQueryType(Routes.PetSitter.Search)} color="purple">
          {tp(`dashboard.newPetSitter.button`)}
        </LinkButton>
      </Box>
    </Box>
  )
}
